/**
 * @generated SignedSource<<f753e6c5782b355156a59b3d58fd364a>>
 * @relayHash a7c74eba5320dece556cc09e185efef4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 2b4e68083c0633ef823c60b14ef283a63bdf8b7ea183ea81f92468c113eca05a

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type ConfluencePrincipalType = "GROUP" | "USER" | "%future added value";
export type ConfluenceUpdateContentDirectRestrictionsInput = {
  add?: ConfluenceDirectRestrictionsAddInput | null | undefined;
  contentId: string;
  includeInvites?: boolean | null | undefined;
  remove?: ConfluenceDirectRestrictionsRemoveInput | null | undefined;
};
export type ConfluenceDirectRestrictionsAddInput = {
  edit?: ConfluenceRestrictionsInput | null | undefined;
  view?: ConfluenceRestrictionsInput | null | undefined;
};
export type ConfluenceRestrictionsInput = {
  restrictions: ReadonlyArray<ConfluenceRestrictionInput | null | undefined>;
};
export type ConfluenceRestrictionInput = {
  principalId: string;
  principalType: ConfluencePrincipalType;
};
export type ConfluenceDirectRestrictionsRemoveInput = {
  edit?: ConfluenceRestrictionsInput | null | undefined;
  view?: ConfluenceRestrictionsInput | null | undefined;
};
export type useUpdateContentDirectRestrictionsMutation$variables = {
  cloudId: string;
  input: ConfluenceUpdateContentDirectRestrictionsInput;
};
export type useUpdateContentDirectRestrictionsMutation$data = {
  readonly confluence_updateContentDirectRestrictions: {
    readonly contentDirectRestrictions: {
      readonly applied: {
        readonly added: {
          readonly edit: {
            readonly __typename: "ConfluenceRestrictionsResult";
          } | null | undefined;
          readonly view: {
            readonly __typename: "ConfluenceRestrictionsResult";
          } | null | undefined;
        } | null | undefined;
        readonly removed: {
          readonly edit: {
            readonly __typename: "ConfluenceRestrictionsResult";
          } | null | undefined;
          readonly view: {
            readonly __typename: "ConfluenceRestrictionsResult";
          } | null | undefined;
        } | null | undefined;
      } | null | undefined;
      readonly confluencePermissionsSummary: {
        readonly __typename: "ConfluencePermissionsSummary";
      };
    } | null | undefined;
    readonly errors: ReadonlyArray<{
      readonly message: string | null | undefined;
    }>;
    readonly success: boolean;
  } | null | undefined;
};
export type useUpdateContentDirectRestrictionsMutation = {
  response: useUpdateContentDirectRestrictionsMutation$data;
  variables: useUpdateContentDirectRestrictionsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "ScalarField",
    "name": "__typename"
  }
],
v2 = [
  {
    "concreteType": "ConfluenceRestrictionsResult",
    "kind": "LinkedField",
    "name": "edit",
    "plural": false,
    "selections": (v1/*: any*/)
  },
  {
    "concreteType": "ConfluenceRestrictionsResult",
    "kind": "LinkedField",
    "name": "view",
    "plural": false,
    "selections": (v1/*: any*/)
  }
],
v3 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      },
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ConfluenceUpdateContentDirectRestrictionsPayload",
    "kind": "LinkedField",
    "name": "confluence_updateContentDirectRestrictions",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "success"
      },
      {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "message"
          }
        ]
      },
      {
        "concreteType": "ConfluenceContentDirectRestrictions",
        "kind": "LinkedField",
        "name": "contentDirectRestrictions",
        "plural": false,
        "selections": [
          {
            "concreteType": "ConfluenceDirectRestrictionsApplied",
            "kind": "LinkedField",
            "name": "applied",
            "plural": false,
            "selections": [
              {
                "concreteType": "ConfluenceDirectRestrictionsResult",
                "kind": "LinkedField",
                "name": "added",
                "plural": false,
                "selections": (v2/*: any*/)
              },
              {
                "concreteType": "ConfluenceDirectRestrictionsResult",
                "kind": "LinkedField",
                "name": "removed",
                "plural": false,
                "selections": (v2/*: any*/)
              }
            ]
          },
          {
            "concreteType": "ConfluencePermissionsSummary",
            "kind": "LinkedField",
            "name": "confluencePermissionsSummary",
            "plural": false,
            "selections": (v1/*: any*/)
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useUpdateContentDirectRestrictionsMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useUpdateContentDirectRestrictionsMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "a7c74eba5320dece556cc09e185efef4",
    "id": "2b4e68083c0633ef823c60b14ef283a63bdf8b7ea183ea81f92468c113eca05a",
    "metadata": {},
    "name": "useUpdateContentDirectRestrictionsMutation",
    "operationKind": "mutation",
    "text": "mutation useUpdateContentDirectRestrictionsMutation($cloudId:ID!,$input:ConfluenceUpdateContentDirectRestrictionsInput!){confluence_updateContentDirectRestrictions(cloudId:$cloudId,input:$input){success,errors{message},contentDirectRestrictions{applied{added{edit{__typename},view{__typename}},removed{edit{__typename},view{__typename}}},confluencePermissionsSummary{__typename}}}}"
  }
};
})();

(node as any).hash = "d5aff274b80f99f689ff4843de64d6f6";

export default node;
